module.exports = __webpack_public_path__ + "static/img/has_survey_page.1e1cb78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/survey/has_survey_page.png
// module id = vNMw
// module chunks = 1